import gql from 'graphql-tag';

export default gql`
  mutation AssignTicket($productId: ID!, $recipientId: ID!, $complimentary: Boolean) {
    assignTicket(data: { productId: $productId, recipientId: $recipientId, complimentary: $complimentary }) {
      id
      product {
        id
      }
      stakeholder {
        id
      }
      event {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/AssignTicket.ts